import { TierType } from '../../features'
import { AiUserTraits } from './AiUserTraits'
import { IsoCountryCode } from './IsoCountryCodes'
import { BaseModel } from './common'

export enum AiUserType {
  NORMAL = 'normal',
  ARTIST = 'artist',
  ADMIN = 'admin',
  UXR = 'uxr'
}

export enum AiUserSubscription {
  FREE = 'free',
  CONVERTER = 'converter',
  CREATOR = 'premium', // Value is `premium' for legacy support reasons
  COMPOSER = 'composer'
}

export enum BillingCycle {
  MONTHLY = 'monthly',
  ANNUAL = 'annual'
}

export enum SubscriptionType {
  TRAINING = 'training'
}

export interface LocationInfo {
  timestamp?: string
  countryCode?: IsoCountryCode // two letter ISO Country Code
  postalCode?: number
  country?: string
  asn?: number
  ip?: string
  metroCode?: number
  timeZone?: string
  longitude?: number
  latitude?: number
  regionName?: string
}

export interface AiUser extends BaseModel {
  type: AiUserType
  tier: TierType
  email: string
  name: string
  firstName: string
  lastName: string | null
  isPhoneNumberVerified?: boolean
  phoneNumberVerificationsSent?: string[]
  phoneNumberVerificationCodeAttempts?: string[]
  subscription: AiUserSubscription
  billingCycle: BillingCycle
  hasPaidSubscription: boolean
  subscriptionPeriodStart: string | null
  subscriptionPeriodEnd: string | null
  subscriptionCancelledAt: string | null
  subscriptionTrialEndsAt: string | null
  subscriptionPauseBeginsAt: string | null
  subscriptionResumesAt: string | null
  lastMinutesUpdatedAt: string | null
  rolloverDownloadMs: number
  pauseRolloverDownloadMs: number
  isArtist: boolean
  isAdmin: boolean
  traits: AiUserTraits | null
  isTrialing: boolean
  hasTrialed: boolean
  countryCode: IsoCountryCode | null
  affiliateLinkUrl: string | null
  voiceModelSlotCount: number
  blendedVoiceModelSlotCount: number
  downloadMs: number | string
  stripeCustomerId: string | null
  churnkeyHmac: string | null

  /**
   * Whether the user is currently paused.
   */
  isPaused: boolean
  /**
   * Whether the user is set to be paused at the end of this billing cycle.
   */
  isPauseBeginningSoon: boolean
  /**
   * Whether the user is currently paused or is set to be paused at the end of this billing cycle
   */
  isPausedOrBeginningSoon: boolean
}

export interface StripeConnectAccount extends BaseModel {
  stripeAccountId: string
  isOnboardingCompleted: boolean
  aiUserId: number
  dashboardUrl: string | null
  totalEarningsInCents: number
}
